import React, {useState} from "react";
import Modal from "@amzn/meridian/modal";
import {FormattedMessage, injectIntl} from "react-intl";
import Alert from "@amzn/meridian/alert";
import PageFooterModal from "../../../commonui/PageFooterModal";
import {
    hasLedPortAboveLimit,
    validateAddAislesForLedController
} from "../../../util/Validations";
import Column from "@amzn/meridian/column";
import {CONFIG_TYPE} from "../../../util/Constants";
import AisleRangeInputModal from "./AisleRangeInputModal";
import {
    createNextAisleConfigs,
    getLastAisleConfig,
} from "../../../util/LEDControllerUtil";
import PropTypes from "prop-types";

const AddMultipleAisleRowsModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, getDraftData, setDraftData, mac, aisleTypes, maxPorts} = props;

    // Visual controls
    const [showAlert, setShowAlert] = useState(false)
    const [showPortLimitAlert, setShowPortLimitAlert] = useState(false)

    // States
    const [startAisle, setStartAisle] = useState(null)
    const [startPort, setStartPort] = useState(null);
    const [aisleCount, setAisleCount] = useState(null)
    const [aisleType, setAisleType] = useState(null)

    // Errors
    const [startAisleError, setStartAisleError] = useState(false)
    const [startPortError, setStartPortError] = useState(false)
    const [aisleCountError, setAisleCountError] = useState(false)
    const [aisleTypeError, setAisleTypeError] = useState(false)

    const stateValues = {
        ledControllerConfig: {
            startAisleLabel: startAisle,
            startPortNumber: startPort,
            aisleCount: aisleCount,
            aisleType: aisleType,
        }
    }

    const resetAssetDetails = () => {
        setStartAisle(null)
        setStartPort(null)
        setAisleCount(null)
        setAisleType(null)
    }

    const resetAssetDetailErrors = () => {
        setStartAisleError(false)
        setStartPortError(false)
        setAisleCountError(false)
    }

    const resetInputState = () => {
        resetAssetDetails()
        resetAssetDetailErrors()
    }

    const onCloseModal = () => {
        setOpen(false)
        resetAssetDetails()
        setShowAlert(false);
        setShowPortLimitAlert(false);
    }

    const addData = (aisleConfigs) => {
        setDraftData({
            data: aisleConfigs,
            stateKey: CONFIG_TYPE.LED_CONTROLLER_CONFIGURATION,
            subKey: mac,
            override: true
        })
    }

    const onClickConfirm = (stateValues) => {
        const {startPortNumber, aisleCount} = stateValues.ledControllerConfig;
        if (validateAddAislesForLedController(stateValues, maxPorts)) {
            setShowAlert(false)
            setShowPortLimitAlert(false)
            const lastAisleConfig = getLastAisleConfig(getDraftData())
            const nextAisleConfigs = createNextAisleConfigs(stateValues.ledControllerConfig,
                lastAisleConfig ? lastAisleConfig.index : 1)
            addData([...getDraftData(), ...nextAisleConfigs]);
            resetInputState();
            setOpen(false);
        } else if (hasLedPortAboveLimit([parseInt(startPortNumber, 10) + parseInt(aisleCount, 10) - 1], maxPorts)) {
            setShowAlert(false)
            setShowPortLimitAlert(true)
        } else {
            setShowAlert(true)
            setShowPortLimitAlert(false)
        }
    }

    return (
        <Modal
            title={formatMessage({id: "device.add_aisles_button_modal"})}
            open={open}
            onOpen={resetInputState}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <AisleRangeInputModal startAisle={startAisle} setStartAisle={setStartAisle}
                                      startAisleError={startAisleError} setStartAisleError={setStartAisleError}
                                      startPort={startPort} setStartPort={setStartPort}
                                      startPortError={startPortError} setStartPortError={setStartPortError}
                                      aisleCount={aisleCount} setAisleCount={setAisleCount}
                                      aisleCountError={aisleCountError} setAisleCountError={setAisleCountError}
                                      aisleType={aisleType} setAisleType={setAisleType}
                                      aisleTypeError={aisleTypeError} setAisleTypeError={setAisleTypeError}
                                      getAisleTypeOptions={aisleTypes}
                                      stateValues={stateValues}
                                      maxPorts={maxPorts}
                />
                {showPortLimitAlert && <Alert type="warning" size="small">
                    <FormattedMessage id="alert.portoutofrange"
                                      defaultMessage="Port numbers must be between 1 and {maxPorts} for this LED controller type!"
                                      values={{maxPorts}}/>
                </Alert>}
            </Column>
            {<PageFooterModal showAlert={showAlert} onCloseModalCallBack={onCloseModal}
                          onClickConfirmCallBack={() => onClickConfirm(stateValues)}
            />}
        </Modal>
    )
}

AddMultipleAisleRowsModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    getDraftData: PropTypes.func.isRequired,
    setDraftData: PropTypes.func.isRequired,
    mac: PropTypes.string.isRequired,
    aisleTypes: PropTypes.array.isRequired,
    maxPorts: PropTypes.number
};

export default injectIntl(AddMultipleAisleRowsModal);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/modal/AddMultipleAisleRowsModal.js